import root from 'window-or-global';


const LocalStorageWrapper = {};

LocalStorageWrapper.getItem = (key) => {
  if (root.localStorage) {
    const lsValue = root.localStorage.getItem(key);

    if (lsValue && lsValue.type && lsValue.type === 'tempLocalStorage' && lsValue.expires) {
      if (!LocalStorageWrapper.checkExpireTime(lsValue.expires)) {
        return null;
      }
    }

    return lsValue;
  }
};

LocalStorageWrapper.setItem = (key, value) => {
  return root.localStorage && root.localStorage.setItem(key, value);
};

LocalStorageWrapper.removeItem = (key) => {
  return root.localStorage && root.localStorage.removeItem(key);
};

LocalStorageWrapper.hasKey = (key) => {
  return root.localStorage && root.localStorage.hasOwnProperty(key);
};

// unixTime takes a number in milliseconds as integer
LocalStorageWrapper.setExpireTime = (key, value, unixTime=null) => {
  if (!unixTime) {
    // default expire time is one hour from current time
    unixTime = new Date().getTime() + 1000 * 60 * 60;
  } else {
    unixTime = new Date().getTime() + unixTime;
  }

  value = {
    value: value,
    expires: unixTime,
    type: 'tempLocalStorage'
  };

  return LocalStorageWrapper.setItem(key, JSON.stringify(value));
};

LocalStorageWrapper.checkExpireTime = (unixTimestamp) => {
  // return false if item is expired
  return !!((unixTimestamp - new Date().getTime()) > 0);
};

export default LocalStorageWrapper;



// WEBPACK FOOTER //
// ../q-jobs/src/utils/LocalStorageWrapper/index.js